import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiHintModule, TuiTextfieldControllerModule, TuiLabelModule } from "@taiga-ui/core";
import { TuiInputPhoneModule } from "@taiga-ui/kit";
import { KwikUIInputPhoneComponent } from "./input-phone.component";

@NgModule({
  declarations: [KwikUIInputPhoneComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiHintModule,
    TuiInputPhoneModule,
    TuiTextfieldControllerModule,
    TuiLabelModule
  ],
  exports: [KwikUIInputPhoneComponent]
})
export class KwikUIInputPhoneModule {}
